export enum CustomerMessages {
  applicationDashboard = "customer.application.dashboard",
  applicationConcretingRequest = "customer.application.concretingRequest",
  applicationConcretingRequestAbbreviated = "customer.application.concretingRequest.abbreviated",
  applicationContract = "customer.application.contract",
  applicationConcreting = "customer.application.concreting",
  applicationInvoice = "customer.application.invoice",
  applicationConcretingApproval = "customer.application.concretingApproval",
  applicationCertificate = "customer.application.certificate",
  applicationContractAmounts = "customer.application.contractAmounts",
  applicationClient = "customer.application.client",
  applicationPermission = "customer.application.permission",
  applicationLogout = "customer.application.logout",
  applicationSettings = "customer.application.settings",
  applicationDocs = "customer.application.docs",
  docsTabManual = "customer.docs.tab.manual",
  docsTabChangelog = "customer.docs.tab.changelog",
  docsIndexTitle = "customer.docs.index",
  docsVersionsTitle = "customer.docs.versions",
  docsLoadError = "customer.docs.loadError",
  docsNoVersions = "customer.docs.noVersions",
  docsVersion = "customer.docs.version",
  docsWhatChanged = "customer.docs.whatChanged",
  docsDetails = "customer.docs.details",
  docsClose = "customer.docs.close",
  docsCancel = "customer.docs.cancel",
  docsKindAddedLabel = "customer.docs.kind.added.label",
  docsKindAddedOne = "customer.docs.kind.added.one",
  docsKindAddedMany = "customer.docs.kind.added.many",
  docsKindImprovedLabel = "customer.docs.kind.improved.label",
  docsKindImprovedOne = "customer.docs.kind.improved.one",
  docsKindImprovedMany = "customer.docs.kind.improved.many",
  docsKindFixedLabel = "customer.docs.kind.fixed.label",
  docsKindFixedOne = "customer.docs.kind.fixed.one",
  docsKindFixedMany = "customer.docs.kind.fixed.many",
  docsKindBreakingLabel = "customer.docs.kind.breaking.label",
  docsKindBreakingOne = "customer.docs.kind.breaking.one",
  docsKindBreakingMany = "customer.docs.kind.breaking.many",
  docsKindOtherLabel = "customer.docs.kind.other.label",
  docsKindOtherOne = "customer.docs.kind.other.one",
  docsKindOtherMany = "customer.docs.kind.other.many",
  docsVersionDetails = "customer.docs.version.details",
  docsVersionRange = "customer.docs.version.range",
  docsVersionNoDetails = "customer.docs.version.noDetails",
  docsVersionDetailsTitle = "customer.docs.version.detailsTitle",
  docsVersionRangeTitle = "customer.docs.version.rangeTitle",
  docsVersionRangeDialogTitle = "customer.docs.version.rangeDialogTitle",
  docsVersionRangeHelp = "customer.docs.version.rangeHelp",
  docsVersionFrom = "customer.docs.version.from",
  docsVersionTo = "customer.docs.version.to",
  docsVersionRangeTooWide = "customer.docs.version.rangeTooWide",
  docsVersionOpenRange = "customer.docs.version.openRange",
  docsVersionLine = "customer.docs.version.line",
  docsVersionFilter = "customer.docs.version.filter",
  docsVersionNoOptions = "customer.docs.version.noOptions",
  newVersionBanner = "customer.newVersion.banner",
  newVersionSee = "customer.newVersion.see",
  newVersionDismiss = "customer.newVersion.dismiss",
  newBadge = "customer.newVersion.badge",
  allUsersStatusIconTitle = "customer.allUsersStatus.iconTitle",
  newUsersStatusIconTitle = "customer.newUsersStatus.iconTitle",
  activeUsersStatusIconTitle = "customer.activeUsersStatus.iconTitle",
  inactiveUsersStatusIconTitle = "customer.inactiveUsersStatus.iconTitle",
  blockedUsersStatusIconTitle = "customer.blockedUsersStatus.iconTitle",
  inactivedUser = "customer.inactiveUser",
  activedUser = "customer.activeUser",
  errorInactivatingUser = "customer.error.inactiveUser",
  errorActivatingUser = "customer.error.activeUser",
  inactivateUserTitle = "customer.title.inactivate",
  activateUserTitle = "customer.title.activate",
  inactivateUserText = "customer.text.inactivate",
  activateUserText = "customer.text.activate",
  inactivateUserButton = "customer.button.inactivate",
  activateUserButton = "customer.button.activate"
}

export interface TranslationCustomerMessages {
  [CustomerMessages.applicationDashboard]: string;
  [CustomerMessages.applicationConcretingRequest]: string;
  [CustomerMessages.applicationConcretingRequestAbbreviated]: string;
  [CustomerMessages.applicationContract]: string;
  [CustomerMessages.applicationContractAmounts]: string;
  [CustomerMessages.applicationConcreting]: string;
  [CustomerMessages.applicationInvoice]: string;
  [CustomerMessages.applicationConcretingApproval]: string;
  [CustomerMessages.applicationCertificate]: string;
  [CustomerMessages.applicationClient]: string;
  [CustomerMessages.applicationPermission]: string;
  [CustomerMessages.applicationLogout]: string;
  [CustomerMessages.applicationSettings]: string;
  [CustomerMessages.applicationDocs]: string;
  [CustomerMessages.docsTabManual]: string;
  [CustomerMessages.docsTabChangelog]: string;
  [CustomerMessages.docsIndexTitle]: string;
  [CustomerMessages.docsVersionsTitle]: string;
  [CustomerMessages.docsLoadError]: string;
  [CustomerMessages.docsNoVersions]: string;
  [CustomerMessages.docsVersion]: string;
  [CustomerMessages.docsWhatChanged]: string;
  [CustomerMessages.docsDetails]: string;
  [CustomerMessages.docsClose]: string;
  [CustomerMessages.docsCancel]: string;
  [CustomerMessages.docsKindAddedLabel]: string;
  [CustomerMessages.docsKindAddedOne]: string;
  [CustomerMessages.docsKindAddedMany]: string;
  [CustomerMessages.docsKindImprovedLabel]: string;
  [CustomerMessages.docsKindImprovedOne]: string;
  [CustomerMessages.docsKindImprovedMany]: string;
  [CustomerMessages.docsKindFixedLabel]: string;
  [CustomerMessages.docsKindFixedOne]: string;
  [CustomerMessages.docsKindFixedMany]: string;
  [CustomerMessages.docsKindBreakingLabel]: string;
  [CustomerMessages.docsKindBreakingOne]: string;
  [CustomerMessages.docsKindBreakingMany]: string;
  [CustomerMessages.docsKindOtherLabel]: string;
  [CustomerMessages.docsKindOtherOne]: string;
  [CustomerMessages.docsKindOtherMany]: string;
  [CustomerMessages.docsVersionDetails]: string;
  [CustomerMessages.docsVersionRange]: string;
  [CustomerMessages.docsVersionNoDetails]: string;
  [CustomerMessages.docsVersionDetailsTitle]: string;
  [CustomerMessages.docsVersionRangeTitle]: string;
  [CustomerMessages.docsVersionRangeDialogTitle]: string;
  [CustomerMessages.docsVersionRangeHelp]: string;
  [CustomerMessages.docsVersionFrom]: string;
  [CustomerMessages.docsVersionTo]: string;
  [CustomerMessages.docsVersionRangeTooWide]: string;
  [CustomerMessages.docsVersionOpenRange]: string;
  [CustomerMessages.docsVersionLine]: string;
  [CustomerMessages.docsVersionFilter]: string;
  [CustomerMessages.docsVersionNoOptions]: string;
  [CustomerMessages.newVersionBanner]: string;
  [CustomerMessages.newVersionSee]: string;
  [CustomerMessages.newVersionDismiss]: string;
  [CustomerMessages.newBadge]: string;
  [CustomerMessages.allUsersStatusIconTitle]: string;
  [CustomerMessages.newUsersStatusIconTitle]: string;
  [CustomerMessages.activeUsersStatusIconTitle]: string;
  [CustomerMessages.inactiveUsersStatusIconTitle]: string;
  [CustomerMessages.blockedUsersStatusIconTitle]: string;
  [CustomerMessages.inactivedUser]: string;
  [CustomerMessages.activedUser]: string;
  [CustomerMessages.errorInactivatingUser]: string;
  [CustomerMessages.errorActivatingUser]: string;
  [CustomerMessages.inactivateUserTitle]: string;
  [CustomerMessages.activateUserTitle]: string;
  [CustomerMessages.inactivateUserText]: string;
  [CustomerMessages.activateUserText]: string;
  [CustomerMessages.inactivateUserButton]: string;
  [CustomerMessages.activateUserButton]: string;
}
